import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface SiteInfo {
  hoursDisplay: string;
  phone: string | null;
  address: string;
  email: string;
  facebook: string | null;
  instagram: string | null;
  mapsUrl: string;
}

/**
 * Hook other components call to read the same site-info cache (single fetch
 * per session). Returns undefined while loading or on error.
 *
 * NOTE: this file historically also exported a <StoreInfoCard> component, which
 * was never rendered anywhere — removed in the 99bd3674 cleanup. The hook is
 * the only live export; kept here to avoid churning its two import sites.
 */
export function useSiteInfo() {
  return useQuery<SiteInfo>({
    queryKey: ["site-info"],
    queryFn: () => api<SiteInfo>("/api/site-info"),
    staleTime: 60 * 60 * 1000, // 1h — static info, low refresh need
    retry: false,
  });
}
